/* eslint-disable no-unused-vars */
import React, { useEffect, lazy, Suspense } from "react";
import { useState } from "react";
import candidateTabsviewStyle from "../Candidate/CandidateTabsview.module.scss";

import { FaChartBar, FaChartPie } from "react-icons/fa";
import { AiFillFunnelPlot } from "react-icons/ai";
// import PieChart from "";
import AdminCandidatePieChart from "../../AdminDashboard/adminTable/adminPerformanceChart/AdminCandidatePieChart";
import { useSelector } from "react-redux";
import AdminTable from "../../AdminDashboard/adminTable/adminPerformanceChart/AdminTable";
import AdminPage from "../../AdminDashboard/adminTable/AdminPage";
import { MdOutlineDashboard } from "react-icons/md";
import AdminIndividual from "../../AdminDashboard/adminTable/adminIndividual";
import AdminAnalytics from "../../AdminDashboard/adminTable/CustomizeAnalytics/AdminAnalytics";
import { BsBarChartFill } from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import TentativeAnalytics from "../../TentativeAnalytics/TentativeAnalytics";

const CandidateFunnel = lazy(() =>
  import("../../CandidateFunnel/CandidateFunnel")
);
const Dashboard = lazy(() => import("../../Dashboard/Dashboard"));
const PieChart = lazy(() =>
  import("../../AdminDashboard/jobDetailsPie/pieChart")
);
function AnalyticsAdmin() {
  const [activeTab, setActiveTab] = useState(1);
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;

  const handleTabClick = (tabValue) => {
    setActiveTab(tabValue);
    window.location.hash = tabValue;
  };

  useEffect(() => {
    const hashValue = window.location.hash.substring(1); // Exclude the '#' symbol

    // Now 'hashValue' contains the value of the hash fragment

    if (hashValue) {
      switch (hashValue) {
        case "Bar view":
          handleTabClick("Bar view");
          break;
        case "candidate Funnel":
          handleTabClick("candidate Funnel");
          break;
        case "Job Pie":
          handleTabClick("Job Pie");
          break;
        case "Candidate Pie":
          handleTabClick("Candidate Pie");
          break;
        case "Admin Joining":
          handleTabClick("Admin Joining");
          break;
        case "AnalyticsCount":
          handleTabClick("AnalyticsCount");
          break;
        case "Candidate Interview":
          handleTabClick("Candidate Interview");
          break;
        default:
          handleTabClick("Bar view");
          break;
      }
    } else {
      handleTabClick("Bar view");
    }
  }, []);
  return (
    <div>
      <div className={`tab-buttons ${candidateTabsviewStyle.tab_buttons}`}>
        <div className={`d-flex ${candidateTabsviewStyle.tab_hr}`}>
          <div
            onClick={() => handleTabClick("Bar view")}
            className={` ${
              activeTab === "Bar view"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            } `}
          >
            <FaChartBar /> Bar view
          </div>
          <div
            onClick={() => handleTabClick("Job Pie")}
            className={` ${
              activeTab === "Job Pie"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            } `}
          >
            <FaChartPie /> Job Category Pie
          </div>
          {!isSuperAdmin && (
            <div
              onClick={() => handleTabClick("Candidate Pie")}
              className={` ${
                activeTab === "Candidate Pie"
                  ? candidateTabsviewStyle.activetag
                  : candidateTabsviewStyle.unactivetag
              } `}
            >
              <MdOutlineDashboard /> Performance Analytics
            </div>
          )}
          {isSuperAdmin && (
            <div
              onClick={() => handleTabClick("Admin Joining")}
              className={` ${
                activeTab === "Admin Joining"
                  ? candidateTabsviewStyle.activetag
                  : candidateTabsviewStyle.unactivetag
              } `}
            >
              <MdOutlineDashboard /> Admin Performance
            </div>
          )}
          {/* {isSuperAdmin && ( */}
            {/* <div
              onClick={() => handleTabClick("Candidate Interview")}
              className={` ${
                activeTab === "Candidate Interview"
                  ? candidateTabsviewStyle.activetag
                  : candidateTabsviewStyle.unactivetag
              } `}
            >
              <SlCalender /> Tentative Interview
            </div> */}
          {/* )} */}

          <div
            onClick={() => handleTabClick("AnalyticsCount")}
            className={` ${
              activeTab === "AnalyticsCount"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            } `}
          >
            <BsBarChartFill /> Analytics Count
          </div>
          {/* <div
            onClick={() => handleTabClick("candidate Funnel")}
            className={` ${
              activeTab === "candidate Funnel"
                ? candidateTabsviewStyle.activetag
                : candidateTabsviewStyle.unactivetag
            }`}
          >
            <AiFillFunnelPlot /> cand idate Funnel
          </div> */}
        </div>
        <hr style={{ borderTop: "10px solid #ccc" }} />
      </div>

      <div className={`tab-content ${candidateTabsviewStyle.tab_content}`}>
        {activeTab === "Bar view" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <Dashboard />
            </Suspense>
          </p>
        )}
        {activeTab === "candidate Funnel" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <CandidateFunnel />
            </Suspense>
          </p>
        )}
        {activeTab === "Job Pie" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <PieChart />
            </Suspense>
          </p>
        )}
        {activeTab === "Candidate Pie" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              <AdminIndividual />
            </Suspense>
          </p>
        )}
        {activeTab === "Admin Joining" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              {/* <AdminTable /> */}
              <AdminPage />
            </Suspense>
          </p>
        )}
        {activeTab === "AnalyticsCount" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              {/* <AdminTable /> */}
              <AdminAnalytics />
            </Suspense>
          </p>
        )}
        {activeTab === "Candidate Interview" && (
          <p>
            <Suspense fallback={<div>Loading...</div>}>
              {/* <AdminTable /> */}
              <TentativeAnalytics />
            </Suspense>
          </p>
        )}
      </div>
    </div>
  );
}

export default AnalyticsAdmin;
